// from general.js
/* global readCookie isMobileView */
// from JSP
/* global displayedPercentFunded */

import '../../external/jquery/jquery.sticky.js'; // modifies jQuery object
import { isMultiProjectGiving } from '../projectpage-react/multiProjectGiving.js';
import {
    addDonateOptionsClose,
    addEventGATrackingToSuggestedDonateAmounts,
    getSuggestedDonateAmounts,
} from '../donateBar/floatingDonateBar.js';


const matchStateDefault = function () {
    $('.js-show-when-give-open').hide();
    $('.js-show-when-give-closed').show();
};

const matchStateOpen = function () {
    $('.js-show-when-give-open').show();
    $('.js-show-when-give-closed').hide();
};

$(document).ready(function () {
    if (displayedPercentFunded < 1 && document.forms.simpleWidgetForm != null) {
        document.simpleWidgetForm.lastSearchURL.value = readCookie('searchTermsURL');
    }

    matchStateDefault();

    // set up suggested amount popover for desktop widget
    $('#simpleWidgetForm input[name=donationAmount]').on('click.suggestedAmount', function () {
        $('#simpleWidgetForm .donation-suggestions-wrapper').show();
    });

    $(document).on('click.suggestedAmount', function (event) {
        const dnSug = $('#simpleWidgetForm .donation-suggestions-wrapper');
        const dnAmt = $('#simpleWidgetForm input[name=donationAmount]');
        if (!dnSug.is(event.target) && dnSug.has(event.target).length === 0 &&
            !dnAmt.is(event.target) && dnAmt.has(event.target).length === 0) {
            dnSug.hide();
        }
    });

    $('#simpleWidgetForm .suggestedAmount').on('click.suggestedAmount', function () {
        let donationAmountString = $(this).find('strong').text();
        if (donationAmountString) {
            donationAmountString = donationAmountString.replace(/[$,]/g, '');
        }
        $('#simpleWidgetForm input[name=donationAmount]').val(donationAmountString);
        $('#simpleWidgetForm .donation-suggestions-wrapper').hide();
        if (!isMultiProjectGiving()) {
            $('#simpleWidgetForm').submit();
        }
    });

    $('.js-match-tooltip').on('click', function () {
        $('#simpleWidgetForm input[name=donationAmount]').val($('.js-completing-amount').text());
        $(this).fadeOut();
        if (!isMultiProjectGiving()) {
            $('#simpleWidgetForm').submit();
        }
    });

    $('#donationAmount').on('click', function () {
        if ($('.js-match-tooltip').is(':visible')) {
            $('.donation-suggestions-wrapper.desktop').hide();
        }
    });
});

function toggleDonateOptions() {
    if ($('#donateOptions').hasClass('on')) {
        $('#donateOptions').removeClass('on');
        $('.donation-wrapper').removeClass('on');
        $('#donateOptions').css({ 'min-height': '0px', height: 0 + 'px' });
        $('#close-give').hide();
        $('#donateBar').show();
        if ($('.has-match').length > 0) {
            matchStateDefault();
        }
    } else {
        $('#donateOptions').addClass('on');
        $('.donation-wrapper').addClass('on');
        $('#donateOptions').css({ 'min-height': $('#donateOptions')[0].scrollHeight + 'px', height: 'auto' });
        $('#close-give').show();
        $('#donateBar').hide();
        if ($('.has-match').length > 0) {
            matchStateOpen();
        }
    }
}

export function getDonateOptions() {
    $('#js-apple-pay-callout').hide();

    // build widget based on giving to proposal
    $('#wishlistHolder').hide();
    if ($('#donateOptions').length === 0) {
        $('#donateBar').before('<div id="donateOptions"></div>');
        $('body').trigger('donateOptionsAdded');
        $('#close-give').on('click.close', function () {
            toggleDonateOptions();
        });
    }

    if ($('#simpleWidgetForm').length > 0) {
        $('#donateOptions').removeClass('inspire-form-holder-mobile').addClass('simple-widget-form-holder-mobile');
        if ($('#donateOptions #simpleWidgetForm').length === 0) $('#simpleWidgetForm').appendTo('#donateOptions');
        const completingDonationAmount = window.completingDonationAmount || window.activeProject.completingDonationAmount;
        if (completingDonationAmount && $('#donateOptions .suggestedAmount').not('.desktop .suggestedAmount').length === 0) {
            $('#donateOptions').prepend(getSuggestedDonateAmounts(completingDonationAmount));
            $('#donateOptions .suggestedAmount').on('click.suggestedAmount', function () {
                $('#donateOptions input[name=donationAmount]').val($(this).text());
                if (!isMultiProjectGiving()) {
                    $('#donateOptions form').submit();
                }
            });
            addEventGATrackingToSuggestedDonateAmounts();
        }
    } else if ($('#inspireForm').length > 0) { // TODO: may have been replaced by FullyFundedProjectCallToAction React component; investigate further and remove this clause if warranted
        $('#donateOptions').removeClass('simple-widget-form-holder-mobile').addClass('inspire-form-holder-mobile');
        if ($('#donateOptions #inspireForm').length === 0) $('#inspireForm').appendTo('#donateOptions');
        if ($('#donateOptions .suggestedAmount').length === 0) {
            $('#inspireForm').before(getSuggestedDonateAmounts());
            $('#donateOptions .suggestedAmount').on('click.suggestedAmount', function () {
                $('#donateOptions input[name=amount]').val($(this).text());
                $('#donateOptions form').submit();
            });
            addEventGATrackingToSuggestedDonateAmounts();
        }
    } else if ($('#quickDonate').length > 0) { // TODO: investigate whether this clause is still used or if this is dead code
        $('#donateOptions').removeClass('simple-widget-form-holder-mobile').addClass('inspire-form-holder-mobile');
        if ($('#donateOptions #quickDonate').length === 0) $('#quickDonate').appendTo('#donateOptions');
        if ($('#donateOptions .suggestedAmount').length === 0) {
            $('#quickDonate').before(getSuggestedDonateAmounts());
            $('#donateOptions .suggestedAmount').on('click.suggestedAmount', function () {
                $('#donateOptions input[name=amount]').val($(this).text());
                $('#donateOptions form').submit();
            });
            addEventGATrackingToSuggestedDonateAmounts();
        }
    }

    if ($('#donateOptions .close').length === 0) addDonateOptionsClose();

    toggleDonateOptions();
}

// This makes the donation bar sticky on desktop
export function makeDonationSticky() {
    if ($(window).width() > 640) {
        if ($('.donation-box').hasClass('funded')) {
            $('.js-give-to-project').removeClass('js-sticky-box');
        }
        $('.js-sticky-box').sticky();
    }
}

// put inspire form back
$(window).bind('resize orientationchange', function () {
    if (!isMobileView() && $('#inspire-form-holder-desktop').length > 0) {
        $('#inspire-form-holder-desktop').append($('#inspireForm'));
    } else if (!isMobileView() && $('#simple-widget-form-holder-desktop').length > 0) {
        $('#simple-widget-form-holder-desktop').append($('#simpleWidgetForm'));
    }
});

$(document).ready(function () {
    // SmoothScroll is actually only used for when people click on # of donors who've given to project and it takes them to the project activity section
    const smoothScroll = function () {
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 74,
                    }, 1000);
                    return false;
                }
            }
        });
    };

    if($(".js-mobile-donation-box").has(".notFunded").length > 0) {
        $("#lead-gen-holder").addClass("expired");
    } else if ($(".js-mobile-donation-box").has(".fully-funded").length > 0) {
        $("#lead-gen-holder").addClass("funded");
    }

    makeDonationSticky();
    $(window).resize(function () {
        makeDonationSticky();
    });

    smoothScroll();
});
